import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Selecter } from 'kinedu-react-components';
import { Spinner } from 'lego-dist';
import { useTranslation } from 'react-i18next';
import useCenters from '../../hooks/centers/UseCenters';
import { formatOptions } from '../../lib/utils';
import { useRouter } from '../../routes';
import { setLocalStorageItem } from 'lib/helpers';
import { KEYS_LOCALSTORAGE } from 'constants/general';
import { setCoreAuthToken } from 'api/CoreInstance';
import GroupService from 'services/GroupService';
import IconSearch from '../uploadActivity/steps/UploadActivityGeneralInfoStep/styles/IconSearch';
import RenderIf from 'components/RenderIf';
import { APP_SECTIONS_PATHS } from 'constants/routes';

// FIXME: Resolve the issue with Eventcalendar, related to Singletone unique context.
/**
 * Once fixed this issue we'll be able to use
 * import { KineduCalendarApi } from 'lego-dist';
 */
declare global {
  interface Window {
    KineduCalendarApi: any;
  }
}

interface CenterFilterProps {}

const StyledCenterFilter = styled.div.attrs(() => ({
  className: 'CenterFilter',
}))`
  width: 256px;
  padding: 20px 10px;

  .Selecter-label {
    color: ${({ theme }) => theme.colors.shadeDarker};
    font-size: 16px;
    letter-spacing: 2.67px;
    padding-left: 19px;
  }

  .Select-menu-outer {
    height: 100px;
  }

  .Select-value {
    width: 100%;
  }

  .Selecter {
    .Select-noresults {
      padding-left: 18px;
    }
  }
`;
/**
 * Setting up the default Center for Eventcalendar smart component.
 */
const setCalendarApi = (center: any) => {
  if (window.KineduCalendarApi && center?.calendar_group_id) {
    window?.KineduCalendarApi?.setCurrentCenterId(center?.calendar_group_id);
  }
};

const getCurrentCenter = (centers: any, activeToken: string) =>
  centers?.find((center: any) => center?.kinedu_classrooms_token?.access_token === activeToken);

const groupService = GroupService.getInstance();

const CenterFilter: React.FC<CenterFilterProps> = () => {
  const [t] = useTranslation();
  const { overrideParamsToUrl, removeParamsToUrl, navigateTo, location } = useRouter();
  const { centerToken, centerList, setActiveCenterById, fetchCenters, loadingCenters } = useCenters();

  useEffect(() => {
    fetchCenters();
    /* eslint-disable-next-line */
  }, []);

  useEffect(() => {
    if (centerToken && centerList?.length) {
      const currentCenter = getCurrentCenter(centerList, centerToken);
      // setCenterInformation(currentCenter);
      setCalendarApi(currentCenter);
    }
  }, [centerList, centerToken]);

  const handleOnChange = (selectedCenter: any) => {
    if (selectedCenter) {
      removeParamsToUrl(['dapId', 'date', 'groupId']);
      setCoreAuthToken(selectedCenter.value);
      setLocalStorageItem(KEYS_LOCALSTORAGE.ACTIVE_CENTER_TOKEN, selectedCenter.value);
      setLocalStorageItem(KEYS_LOCALSTORAGE.ACTIVE_GROUP_ID, '');
      groupService.setGroupList$([]);
      setActiveCenterById(selectedCenter.id);
      setCalendarApi(selectedCenter);
      overrideParamsToUrl({ centerId: selectedCenter.id });
      if (location.pathname.includes(APP_SECTIONS_PATHS.MY_PLANS)) {
        navigateTo(APP_SECTIONS_PATHS.DAP);
      }
    }
  };

  const centersOptions = formatOptions(
    centerList,
    ['name'],
    ['kinedu_classrooms_token', 'access_token'],
    (item: any) => ({
      id: item.id,
      calendar_group_id: item.calendar_group_id,
    }),
  );

  return (
    <StyledCenterFilter>
      <RenderIf
        condition={centersOptions?.length > 1}
        loading={loadingCenters}
        loadingState={<Spinner loading position="absolute" />}
      >
        <Selecter
        theme="Scaffolding"
        label={t('MENU.CURRENT_CENTER')}
        options={centersOptions}
        value={centerToken}
        onChange={handleOnChange}
        isSearchable
        hidePlaceholderOnSelect
        iconRender={<IconSearch />}
      />
      </RenderIf>
    </StyledCenterFilter>
  );
};

CenterFilter.defaultProps = {};

export default CenterFilter;
